/**
 * @generated SignedSource<<058920bf2a8b374d3f5fedba43459ce3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandStatCards_brand$data = {
  readonly metricsDaily: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly appSales: number;
        readonly appSessions: number;
        readonly date: any;
        readonly newAppUsers: number;
      };
    }>;
  };
  readonly orderMetricsSummary: {
    readonly attributionRate: number;
    readonly kinnOrders: number;
    readonly totalOrders: number;
  };
  readonly " $fragmentType": "InternBrandStatCards_brand";
};
export type InternBrandStatCards_brand$key = {
  readonly " $data"?: InternBrandStatCards_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandStatCards_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandStatCards_brand",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "os": {
              "isNull": true
            }
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 30
        }
      ],
      "concreteType": "GraphQLBrandMetricDailyConnection",
      "kind": "LinkedField",
      "name": "metricsDaily",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLBrandMetricDailyEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLBrandMetricDaily",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "appSales",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "appSessions",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newAppUsers",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "metricsDaily(filters:{\"os\":{\"isNull\":true}},first:30)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandOrderMetricsSummary",
      "kind": "LinkedField",
      "name": "orderMetricsSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalOrders",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kinnOrders",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attributionRate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "bc0df180ba2bddbb4f94ebb0db2929f5";

export default node;
